<template lang="pug">



section
  .top 
    MouserGeneralHeader

  .content

    .mouser
      ErrorMessage
      MouserConfiguratorHeader
    
    .configurator__grid
      SelectorConnector(:parameter="'connector_left'")
      MouserSelectorCable(:parameter="'cable'")
      SelectorConnector(:parameter="'connector_right'")

    MouserConfiguratorFooter

</template>

<script>
// @ is an alias to /src
import ErrorMessage from "@/components/configurator/ErrorMessage";
import MouserGeneralHeader from "@/components/configurator/MouserGeneralHeader";
import MouserConfiguratorHeader from "@/components/configurator/MouserConfiguratorHeader";
import SelectorConnector from "@/components/configurator/SelectorConnector";
import MouserSelectorCable from "@/components/configurator/MouserSelectorCable";
import MouserConfiguratorFooter from "@/components/configurator/MouserConfiguratorFooter";


export default {
  name: "MouserConfigurator",
  components: {
    MouserGeneralHeader,
    MouserConfiguratorHeader,
    MouserConfiguratorFooter,
    SelectorConnector,
    MouserSelectorCable,
    ErrorMessage
  },
};
</script>


<style lang="scss" scoped>

.top {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
}

.content {
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: clamp(1.125rem, 3vw, 1rem);
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
}

.top {
  display: flex;
  position: relative;
}

.configurator__grid {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  gap: clamp(0.3875rem, 2vw, 1rem);
  position: relative;
}
</style>